import { jsx as _jsx } from "preact/jsx-runtime";
import postcodeAction from '../postcode.action';
import MaterialErrorPage from './error.page';
import MaterialLayout from './material.layout';
import materialLoader from './material.loader';
import MaterialPage from './material.page';
import materialSearchLoader from './search.loader';
import MaterialSearchPage from './search.page';
const routes = [
    {
        path: '/:postcode/material',
        element: _jsx(MaterialLayout, {}),
        children: [
            {
                index: true,
                element: _jsx(MaterialPage, {}),
                errorElement: _jsx(MaterialErrorPage, {}),
                loader: materialLoader,
            },
            {
                path: 'search',
                element: _jsx(MaterialSearchPage, {}),
                action: postcodeAction,
                loader: materialSearchLoader,
                errorElement: _jsx(MaterialErrorPage, {}),
            },
        ],
    },
];
export default routes;
